import { defineMessages } from 'react-intl';
import { number } from 'yup';

import { ValidateInput } from '../types/api/graphql';

export type FormError = {
  fieldName: string;
  validation?: ValidateInput;
  message: string;
};

export enum FormMessageType {
  DEFAULT = 'DEFAULT',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export type FormMessage = {
  type: FormMessageType;
  message: JSX.Element | string;
};

export const messages = defineMessages({
  generic: {
    id: 'common.errors.generic',
  },
  required: {
    id: 'common.errors.field-required',
  },
  minLength: {
    id: 'common.errors.min-length',
  },
  maxLength: {
    id: 'common.errors.max-length',
  },
  minValue: {
    id: 'common.errors.min-value',
  },
  maxValue: {
    id: 'common.errors.max-value',
  },
  invalidRegEx: {
    id: 'common.errors.invalid-input',
  },
  invalidEmail: {
    id: 'common.errors.invalid-mail-address',
  },
  invalidPhone: {
    id: 'common.errors.invalid-phone',
  },
  invalidZipCode: {
    id: 'common.errors.invalid-zip-code',
  },
  invalidTime: {
    id: 'common.errors.invalid-time',
  },
  invalidEndTime: {
    id: 'common.errors.invalid-end-time',
  },
  invalidDate: {
    id: 'common.errors.invalid-date',
  },
  invalidEndDate: {
    id: 'common.errors.invalid-end-date',
  },

  invalidWebsite: {
    id: 'common.errors.invalid-website',
  },
  invalidNumber: {
    id: 'common.errors.invalid-number',
  },
  invalidPassword: {
    id: 'common.errors.invalid-password',
  },
  invalidNotMatching: {
    id: 'common.errors.not-matching',
  },
});

export const trim = (value: string) =>
  value?.replace(/(^([ ]*<p><br><\/p>)*)|((<p><br><\/p>)*[ ]*$)/gi, '').trim();

export const nan = (value: string | null | undefined) =>
  Number.isNaN(value) ? null : value;

export const toNumber = (value?: string | null | undefined) =>
  value ? value.replace(/[^0-9]/, '') : '';

export const nanNumber = () => number().transform(nan).nullable().default(null);

export const regExEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const regExPhone = /^((\+[0-9]{10,11})|([0-9]{10,11}))$/;
export const regExInternationalPhone = /^\+(?:[0-9] ?){6,14}[0-9]$/;
export const regExDate = /^([0-9]{4})-([0-9]{2})-([0-9]{2})?$/;
export const regExWebsite =
  /^(http[s]?:\/\/(www\.)?|ftp:\/\/(www\.)?|www\.){1}([0-9A-Za-z-.@:%_+~#=]+)+((\.[a-zA-Z]{2,3})+)(\/(.)*)?(\?(.)*)?/;
